import {
  Heading,
  HeadingLevel,
  ThemeColorTextPath,
  useResponsivePropValue,
  ValueByDevice,
} from 'platform/foundation';

import {TestIdProps} from 'shared/web';

import {SkeletonLoadingBox} from '../../EntityHeader/components/SkeletonLoadingBox';

const DEFAULT_SIZE: ValueByDevice<HeadingLevel> = [4, 2, 2];

interface EntityHeaderTitleProps extends TestIdProps {
  title?: string;
  isLoading?: boolean;
  size?: HeadingLevel | ValueByDevice<HeadingLevel>;
  color?: ThemeColorTextPath | ValueByDevice<ThemeColorTextPath | undefined>;
}

export function EntityHeaderTitle(props: EntityHeaderTitleProps) {
  const size = useResponsivePropValue(props.size ?? DEFAULT_SIZE);
  const color = useResponsivePropValue(props.color);

  if (!props.title) {
    return null;
  }

  return (
    <SkeletonLoadingBox isLoading={props.isLoading} height={8} width={120}>
      <Heading color={color} data-testid={props['data-testid']} size={size}>
        {props.title}
      </Heading>
    </SkeletonLoadingBox>
  );
}
